import React, { Component } from 'react'
import { connect } from 'react-redux'
import { groupedTimes } from 'cogsworth/utils/dates'
import moment from 'moment-timezone'
import { setTime } from 'cogsworth/utils/store'
import Loading from 'cogsworth/components/Loading/Loading'
import { fetchAdhocServiceAvailableTimes } from 'cogsworth/utils/availableTimes'
import DaySelectionNav from '../MonthView/DaySelection/Navigation/Navigation'
import './adHocView.css'

const DAYS_PER_PAGE = 7

class AdHocView extends Component {
  constructor(props){
    super(props)

    this.state = {
      loading: true,
      times: [],
      pageIndex: 0,
    }

    this.dayHeader = this.dayHeader.bind(this)
    this.dayColumn = this.dayColumn.bind(this)
    this.navigate = this.navigate.bind(this)
  }

  async fetch(props) {
    const { endpoint } = props

    if(!endpoint) {
      this.setState({ loading: false })
      return
    }

    const availableTimes = await fetchAdhocServiceAvailableTimes({
      adHocServiceId: props.adHocService.id,
      ignoreAppointmentId: endpoint.resourceType === "appointment" ? endpoint.resourceId : null,
    })

    this.setState({
      loading: false,
      times: availableTimes,
    })
  }

  componentDidMount(){
    this.fetch(this.props)
  }

  componentWillReceiveProps(nexProps){
    this.fetch(nexProps)
  }

  lastPageIndex() {
    return Math.floor(this.state.times.length / DAYS_PER_PAGE) - 1
  }

  navigate(direction){
    const change = direction === 'prev' ? - 1 : 1
    const newPageIndex = this.state.pageIndex + change

    if(newPageIndex > this.lastPageIndex() || newPageIndex < 0) {
      return
    }

    this.setState({ pageIndex: newPageIndex })
  }

  dayHeader(day){
    return (
      <div className="day-header">
        <span>{ day.format('ddd') }</span><br />
        <strong>{ day.format('MMM D') }</strong>
      </div>
    )
  }

  handleTimeSelected(time) {
    this.props.dispatch(setTime(time))
    this.props.onTimeSelected && this.props.onTimeSelected(time)
  }

  dayColumn({ day, times }){
    return (
      <div className="day-column">
        { this.dayHeader(day) }
        <div className="day-times">
          {
            times.map(time => (
              <div
                className="day-time border-primary-color font-primary-color"
                onClick={() => this.handleTimeSelected(time)}
              >{ moment.tz(time, this.props.timezone).format(this.props.dateFormat.time) }</div>
            ))
          }
        </div>
      </div>
    )
  }

  render() {
    if(this.state.loading) {
      return <Loading size="small" relative={true} />
    }

    if(this.state.times.length === 0) {
      return <p className="text-center">There are no available times for this service.</p>
    }

    const days = groupedTimes(this.state.times, this.props.timezone).splice(this.state.pageIndex * DAYS_PER_PAGE, DAYS_PER_PAGE)

    return (
      <div className="ad-hoc-view">
        <DaySelectionNav
          onNav={this.navigate}
          navPrev={this.state.pageIndex > 0}
          navNext={this.state.pageIndex < this.lastPageIndex()}
        />
        <div className="days">
          { days.map(this.dayColumn) }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  timezone: state.timezone,
  endpoint: state.endpoint,
})
export default connect(mapStateToProps)(AdHocView)
